export const buildGetStatesApi = () => ({
    method: 'GET',
    url: '/api/billing/ibge/states',
});

export const buildGetCitiesApi = uf => ({
    method: 'GET',
    url: `/api/billing/ibge/cities/${uf}`,
});
